/* istanbul ignore file */
import React from 'react';
import { DropDownFilter } from 'framework/list';
import { Dropdown } from 'framework/form';
import { ASSET_CATEGORIES_TYPES, ASSET_CATEGORIES_OPTIONS } from 'domain/finance/assets/useAssetService';

const DROPDOWN_OPTIONS = Object.entries(ASSET_CATEGORIES_TYPES).reduce(
  (acc: { value?: string; label: string }[], [key, options]) => {
    acc.push(
      {
        label: ASSET_CATEGORIES_OPTIONS[key],
      },
      ...Object.entries(options).map(([value, label]) => ({
        value,
        label,
      })),
    );

    return acc;
  },
  [],
);

const AssetTypeDropdownFilter = (props: any) => {
  return (
    <DropDownFilter {...props}>
      <Dropdown options={DROPDOWN_OPTIONS || []} {...props} />
    </DropDownFilter>
  );
};

export default AssetTypeDropdownFilter;
